var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-link',{attrs:{"type":_vm.typename,"underline":_vm.underline,"disabled":_vm.disabled,"icon":_vm.icon},nativeOn:{"click":function($event){_vm.hrefBack?_vm.hrefBack(_vm.linkhref): null}}},[_vm._v(_vm._s(_vm.linktitle))])
}
var staticRenderFns = []

export { render, staticRenderFns }